import URL from '@/http/remplacement';
export default {
  namespaced: true,
  state: {
    currentRemplacement: null,
  },

  getters: {
    currentRemplacement: (state) => state.currentRemplacement,
    chantier: (state) => state.chantier,
  },

  mutations: {
    SET_CURRENT_REMPLACEMENT(state, value) {
      state.currentRemplacement = value;
    },
  },

  actions: {
    setCurrentRemplacement({ commit }, payload) {
      commit('SET_CURRENT_REMPLACEMENT', payload);
    },

    getRemplacement({ commit }, { id, edit = false }) {
      return window.axios
        .get(URL.REMPLACEMENT + '/' + id, { params: { edit } })
        .then((resp) => {
          commit('SET_CURRENT_REMPLACEMENT', resp.data.remplacement);
        })
        .catch(() => {
          commit('SET_CURRENT_REMPLACEMENT', null);
        });
    },
  },
};
